import { GlButton, GlIcon, GlDisclosureDropdownItem, GlDisclosureDropdownGroup, GlDisclosureDropdown, GlTooltipDirective, GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__, sprintf } from '~/locale';
import PromoteMilestoneModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/milestones/components/promote_milestone_modal.vue?vue3';
import DeleteMilestoneModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/milestones/components/delete_milestone_modal.vue?vue3';
export default {
    name: 'MoreActionsDropdown',
    components: {
        GlButton,
        GlIcon,
        GlDisclosureDropdownItem,
        GlDisclosureDropdownGroup,
        GlDisclosureDropdown,
        PromoteMilestoneModal,
        DeleteMilestoneModal
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        GlToastMixin
    ],
    inject: [
        'id',
        'title',
        'isActive',
        'showDelete',
        'isDetailPage',
        'milestoneUrl',
        'editUrl',
        'closeUrl',
        'reopenUrl',
        'promoteUrl',
        'groupName',
        'issueCount',
        'mergeRequestCount',
        'size'
    ],
    data () {
        return {
            isDropdownVisible: false,
            isDeleteModalVisible: false,
            isPromoteModalVisible: false
        };
    },
    computed: {
        widthClasses () {
            return this.size === 'small' ? 'gl-min-w-6' : 'gl-min-w-7';
        },
        copiedToClipboard () {
            return this.$options.i18n.copiedToClipboard;
        },
        editItem () {
            return {
                text: this.$options.i18n.edit,
                href: this.editUrl,
                extraAttrs: {
                    'data-testid': 'milestone-edit-item'
                }
            };
        },
        promoteItem () {
            return {
                text: this.$options.i18n.promote,
                extraAttrs: {
                    'data-testid': 'milestone-promote-item'
                }
            };
        },
        closeItem () {
            return {
                text: this.$options.i18n.close,
                href: this.closeUrl,
                extraAttrs: {
                    class: {
                        '@sm/panel:!gl-hidden': this.isDetailPage
                    },
                    'data-testid': 'milestone-close-item',
                    'data-method': 'put',
                    rel: 'nofollow'
                }
            };
        },
        reopenItem () {
            return {
                text: this.$options.i18n.reopen,
                href: this.reopenUrl,
                extraAttrs: {
                    class: {
                        '@sm/panel:!gl-hidden': this.isDetailPage
                    },
                    'data-testid': 'milestone-reopen-item',
                    'data-method': 'put',
                    rel: 'nofollow'
                }
            };
        },
        deleteItem () {
            return {
                text: this.$options.i18n.delete,
                variant: 'danger',
                extraAttrs: {
                    'data-testid': 'milestone-delete-item'
                }
            };
        },
        copyIdItem () {
            return {
                text: sprintf(this.$options.i18n.copyTitle, {
                    id: this.id
                }),
                action: ()=>{
                    this.$toast.show(this.copiedToClipboard);
                },
                extraAttrs: {
                    'data-testid': 'copy-milestone-id',
                    itemprop: 'identifier'
                }
            };
        },
        showDropdownTooltip () {
            return !this.isDropdownVisible ? this.$options.i18n.actionsLabel : '';
        },
        showTestIdIfNotDetailPage () {
            return !this.isDetailPage ? 'milestone-more-actions-dropdown-toggle' : false;
        },
        hasEditOptions () {
            return Boolean(this.closeUrl || this.reopenUrl || this.editUrl || this.promoteUrl);
        }
    },
    methods: {
        showDropdown () {
            this.isDropdownVisible = true;
        },
        hideDropdown () {
            this.isDropdownVisible = false;
        },
        setDeleteModalVisibility (visibility = false) {
            this.isDeleteModalVisible = visibility;
        },
        setPromoteModalVisibility (visibility = false) {
            this.isPromoteModalVisible = visibility;
        }
    },
    primaryAction: {
        text: s__('Milestones|Promote Milestone'),
        attributes: {
            variant: 'confirm'
        }
    },
    cancelAction: {
        text: __('Cancel'),
        attributes: {}
    },
    i18n: {
        actionsLabel: s__('Milestone|Milestone actions'),
        close: __('Close'),
        delete: __('Delete'),
        edit: __('Edit'),
        promote: __('Promote'),
        reopen: __('Reopen'),
        copyTitle: s__('Milestone|Copy milestone ID: %{id}'),
        copiedToClipboard: s__('Milestone|Milestone ID copied to clipboard.')
    }
};
